import { applyLandingBrand } from "@/lib/siteHosts"

export const heroContent = applyLandingBrand({
  kicker: "2026 Industry Benchmark:",
  h1: "83.1% of Roofing Contractors Lose $15k/Week Due to Slow Response Times",
  lead: "Based on a blind audit of 1,201 active roofing companies measuring real-world response gaps, lead decay, and uncaptured revenue. Calculate your company's hidden leakage below.",
  cta: "View the Full 2026 Roofing Report",
  chip: "Find My Company in the Benchmark",
  micros: [
    "Deployment time: 12 minutes",
    "No credit card required",
    "Full turnkey setup available",
  ],
  caption: "FRACTOLABS RESEARCH LAB • ROOFING INDUSTRY BENCHMARK",
  tabs: [
    {
      id: "statistics",
      label: "General Statistics",
      lines: [
        "[83.1%] - Failed to respond within 24 hours",
        "",
        "[4h 12m] - Industry average response delay",
        "",
        "[0.12%] - Companies answering in under 60 seconds",
        "",
        "[$52,400/mo] - Average estimated revenue leakage per contractor",
      ],
    },
    {
      id: "company",
      label: "Find My Roofing Company",
      search: {
        label: "Search",
        placeholder: "[ Enter your Company Name or Domain]",
        button: "Search",
      },
    },
  ],
})
